import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/ExistingDebtPlans`;
const reportUrl = `${process.env.REACT_APP_API_ENDPOINT}/Reports/ExistingPlanByAgreement`;

class ExistingDebtPlanService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public getExistPlansAgreementList(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "planRestructureList" });
    } catch (e) {
      throw e;
    }
  }

  public getExistingDebtPlansList(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "list" });
    } catch (e) {
      throw e;
    }
  }

  public getExistingDebtPlan(id: number): Promise<IApiResponse | void> {
    try {
      return super.getById(id);
    } catch (e) {
      throw e;
    }
  }

  public updateExistingDebtPlan(
    body: any,
    id: number
  ): Promise<IApiResponse | void> {
    try {
      return super.update(body, id);
    } catch (e) {
      throw e;
    }
  }

  public removeExistingDebtPlan(id: number): Promise<IApiResponse | void> {
    try {
      return super.delete(id);
    } catch (e) {
      throw e;
    }
  }

  public getExistingDebtPlanSummary(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "summary" });
    } catch (e) {
      throw e;
    }
  }

  public getExistingDebtPlanPaymentAndRestructureSummary(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "summary/dashboard" });
    } catch (e) {
      throw e;
    }
  }
  public printExistingPlanByAgreement(
    id: number
  ): Promise<IApiResponse | void> {
    this.setUrl(reportUrl);
    try {
      return super.getFileById(id);
    } catch (e) {
      throw e;
    }
  }
}
const existingDebtPlanAPI = new ExistingDebtPlanService(url);
export default existingDebtPlanAPI;
